/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-31 13:59:29
 * @LastEditors: m
 * @LastEditTime: 2020-08-24 10:31:40
 */

// const httpURL = "http://es.10led.com:8086/api";
// const fileUrl = "http://es.10led.com:8086/download/";
// const Name = "四川金丰锐特钣金CRM系统";
// const LOGO = require('../img/JFLOGO.jpg');
// 

// 金丰锐特
const httpURL = "https://bjc-api.ledv8.com/api";
const fileUrl = "https://bjc-api.ledv8.com/download/";
const Name = "四川金丰锐特钣金CRM系统";
const LOGO = require('../img/JFLOGO.jpg');

// 金丰锐特交安
// const httpURL = "https://ja-api.ledv8.com/api";
// const fileUrl = "https://ja-api.ledv8.com/download/";
// const Name = "四川金丰锐特交安CRM系统";
// const LOGO = require('../img/JFLOGO.jpg');


export default {
    httpURL,
    fileUrl,
    Name,
    LOGO,
};
//说明：启动命令npm  run  dev   打包命令：npm run build